export interface YourLumpSumAllowances {
    lsaQuestion: string;
    lsDbaQuestion: string;
    lsaLgaProtectionQuestion: string;
    protectionType: string;
    riskAndStaticQuestion:any[];
}
